const state = {
    hideFields: [],
    selectOrderHideFields: [],
    orderFormData: {},
    folderList: [],
    total: 0,
    selectTests: [],
    sampleData: {},
    virtualId: void 0,
    sampleType: [],
    originSampleType: [],
    selectParameterFields: [],
    folderTask: [],
    positionSelect: [],
};

const mutations = {
    setHideFields(state, data) {
        state.hideFields = data.hiddenFields.map(hf => {
            return hf.field;
        });
    },

    setSelectOrderHideFields(state, data) {
        state.selectOrderHideFields = data.hiddenFields.map(hf => {
            return hf.field;
        });
    },

    setOrderFormData(state, data) {
        state.orderFormData = data;
    },

    setFolderList(state, data) {
        state.folderList = data;
    },

    setFolderTask(state, data) {
        state.folderTask = data;
    },

    setTotal(state, t) {
        state.total = t;
    },

    setSelectTests(state, data) {
        state.selectTests = data;
    },

    setSampleData(state, data) {
        state.sampleData = data;
    },

    setVirtualId(state, data) {
        state.virtualId = data;
    },

    setSampleType(state, t) {
        state.sampleType = t.map(s => {
            return {
                label: s.unitName,
                value: s.code
            };
        });
    },

    setPositionSelect(state, data) {
        state.positionSelect = data.map(item => {
            return {
                label: item.codeName,
                value: item.code
            }
        })
    },

    setSelectParameterFields(state, f) {
        state.selectParameterFields = f.mtlCategorySampleParametersBeans.map(p => {
            return {
                label: p.ext$.unitname ? `${p.sampleTypeParameters}(${p.ext$.unitname})` : p.sampleTypeParameters,
                field: p.id.toString(),
                type: p.dataType,
                ...(p.dataType === 'select' ? {
                    items: p.dataSource.map(res => {
                        return {
                            label: res.codeName,
                            value: res.code
                        }
                    })
                } : {}),
                span: 8
            };
        });
    }
};
const actions = {
    createOnlineFolders() {
        return this.service.post('/secure/css/module/online-folders', JSON.stringify({
            b: ['', [{}]]
        }));
    },

    getOrderFormData(context, id) {
        return this.service.get(`/secure/css/module/online-orderform/${id}`).then(({
            data
        }) => {
            context.commit('setOrderFormData', data);
        }).catch(() => {
            context.commit('setOrderFormData', {});
        });
    },

    getFolderTask(context, id) {
        return this.service
            .post(
                `/secure/css/module/online-folders/folderTasks/queries`,
                JSON.stringify({
                    p: {
                        f: {
                            folderId_SEQ: id
                        },
                        n: -1,
                        s: 50,
                        qf: {},
                        o: []
                    }
                })
            )
            .then(({
                data
            }) => {
                context.commit('setFolderTask', data.rows);
            });
    },

    getHideFields(context) {
        this.service.post('/secure/css/action/select-folder-hide-fields').then(({
            data
        }) => {
            context.commit('setHideFields', data);
        });
    },

    getSelectOrderHideFields(context) {
        this.service.post('/secure/css/action/select-order-hide-fields').then(({
            data
        }) => {
            context.commit('setSelectOrderHideFields', data);
        });
    },

    getPositionSelect(context) {
        this.service.get('/secure/css/action/position/select-core-code').then(({
            data
        }) => {
            context.commit('setPositionSelect', data);
        });
    },

    saveOrderFormData(context, formData) {
        return this.service.put(
            '/secure/css/module/online-orderform/instant',
            JSON.stringify({
                p: {
                    saveForm: '1'
                },
                b: ['limsOrderFormServiceImpl', [formData]]
            })
        );
    },

    getFolderList(context, p) {
        // { f: { cssStatus }, n: -1, qf: {}, o: [] }
        return this.service.post('/secure/css/action/select-folder-list', JSON.stringify({
            p
        })).then(({
            data
        }) => {
            context.commit('setFolderList', data.rows);
            context.commit('setTotal', data.total);
        });
    },

    getOrderTemp(context, p) {
        // { f: { cssStatus }, n: -1, qf: {}, o: [] }
        return this.service.post('/secure/css/action/select-order-tmpls', JSON.stringify({
            p
        }));
    },

    getSelectTests(context, p) {
        return this.service.post('/secure/css/action/select-tests', JSON.stringify({
            p
        })).then(({
            data
        }) => {
            context.commit('setSelectTests', data.rows);
        });
    },

    insertOrderTask(context, data = []) {
        return this.service.post(
            '/secure/css/module/online-folders/action/insert-folder-ordertask',
            JSON.stringify({
                p: {
                    type: 'limsOrdersAdd',
                    addType: 'test',
                    syncEntrustItem: '0',
                    syncTestUser: '1',
                    syncStatus: null,
                    addFrom: null
                },
                b: ['', data]
            })
        );
    },

    getSampleData(context, p) {
        //  {"p":{"f":{"longRangeStandard_DIFFER":"1"},"n":-1,"s":50,"qf":{},"o":[{"orderNo":"desc"}]}}
        return this.service
            .post(`/secure/css/module/online-folders/${p.folderId}/orders/queries`, JSON.stringify({
                p
            }))
            .then(({
                data
            }) => {
                context.commit('setSampleData', data);
                // context.commit('setTotal', data.total);
            });
    },

    getNextIdentity(context) {
        return this.service.get('/secure/css/module/online-orderform/action/getNextIdentity').then(({
            data
        }) => {
            context.commit('setVirtualId', data);
        });
    },

    getQSampleType(context, p) {
        return this.service
            .post('/secure/css/action/units/queries-by-sampleType', JSON.stringify({
                p
            }))
            .then(({
                data
            }) => {
                context.commit('setSampleType', data);
            });
    },

    insertOrderLims(context, p) {
        return this.service.post('/secure/css/module/online-folders/action/insert-order-lims', JSON.stringify(p));
    },

    getSelectParameterFields(context, sampleType) {
        return this.service.get(`/secure/css/action/${sampleType}/select-parameter-fields`).then(({
            data
        }) => {
            context.commit('setSelectParameterFields', data);
        });
    },

    submitToLims(context, p) {
        return this.service.post('/secure/css/module/online-folders/action/submit-to-lims', JSON.stringify(p));
    }
};

const getters = {
    panelFields(state, getters, rootState) {
        return [{
                id: 'wtf',
                title: '委托方信息',
                gutter: 32,
                fieldGroup: [
                    [{
                            label: '委托人/单位',
                            field: 'companyName',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入委托人/单位'
                            }]
                        },
                        {
                            label: '电话(委托方)',
                            field: 'contactPhone',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入电话(委托方)'
                            }]
                        },
                        {
                            label: '传真(委托方)',
                            field: 'fax',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入传真'
                            }]
                        },
                        {
                            label: '邮编(委托方)',
                            field: 'zipCode',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入邮编'
                            }]
                        },
                        {
                            label: '邮箱(委托方)',
                            field: 'email',
                            span: 8,
                            rules: [{
                                    required: false,
                                    message: '请输入邮箱'
                                },
                                {
                                    min: 1,
                                    max: 99,
                                    message: '字符长度必须在 1-99 之间'
                                }
                            ]
                        },
                        {
                            label: '送样人',
                            field: 'sampler',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入送样人'
                            }]
                        },
                        {
                            label: '委托日期',
                            field: 'entrustDate',
                            type: 'date',
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请输入委托日期'
                            }]
                        },
                        {
                            label: '地址(委托方)',
                            field: 'companyAddress',
                            span: 8
                        },
                        {
                            label: 'EMS号',
                            field: 'cssEmsNumber',
                            span: 8
                        }
                    ]
                ]
            },
            {
                id: 'ypxx',
                title: '合同信息',
                gutter: 32,
                fieldGroup: [
                    [{
                            label: '样品类型',
                            field: 'sampleType',
                            type: 'select',
                            items: rootState.sampleType,
                            showSearch: true,
                            span: 8,
                            rules: [{
                                required: true,
                                message: '请选择样品类型'
                            }]
                        },
                        {
                            label: '来样方式',
                            field: 'samplingWay',
                            type: 'select',
                            items: [{
                                    label: '寄样',
                                    value: '03'
                                },
                                {
                                    label: '送样',
                                    value: '02'
                                },
                                {
                                    label: '抽样',
                                    value: '01'
                                }
                            ],
                            span: 8,
                            rules: [{
                                required: false,
                                message: '请选择样品类型'
                            }]
                        },
                        {
                            label: '检测样品状态',
                            field: 'sealingSampleStatus',
                            span: 8
                        },
                        {
                            label: '样品数量',
                            field: 'sampleCount',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '样品单位',
                            field: 'sampleUnit',
                            type: 'select',
                            span: 8,
                            items: rootState.sampleUnit
                        },
                        {
                            label: '留样数量',
                            field: 'sampleNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '物检室领用数量',
                            field: 'inspectionRoomNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '化学一室领用数量',
                            field: 'oneRoomNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '化学二室领用数量',
                            field: 'twoRoomNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '烟叶室领用数量',
                            field: 'tobaccoLeafNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '评吸会领用数量',
                            field: 'commentaryNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '安全室领用数量',
                            field: 'safeRoomNumber',
                            type: 'number',
                            min: 0,
                            span: 8
                        },
                        {
                            label: '样品基数',
                            field: 'samplingBase',
                            type: 'number',
                            min: 1,
                            span: 8
                        },
                        {
                            label: '抽样单位名称',
                            field: 'samplingUnitName',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 99,
                                message: '字符长度必须在 0-66 之间'
                            }]
                        },
                        {
                            label: '抽样时间',
                            field: 'samplingTime',
                            type: 'date',
                            span: 8
                        },
                        {
                            label: '抽样依据',
                            field: 'samplingBasis',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 99,
                                message: '字符长度必须在 0-66 之间'
                            }]
                        },
                        {
                            label: '抽样人',
                            field: 'samplingPerson',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 99,
                                message: '字符长度必须在 0-18 之间'
                            }]
                        },
                        {
                            label: '抽样地点',
                            field: 'sampleLocation',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 300,
                                message: '字符长度必须在 0-300 之间'
                            }]
                        },
                        {
                            label: '样品来源',
                            field: 'sampleSources',
                            span: 8,
                            type: 'select',
                            items: [{
                                    label: '非零售户',
                                    value: 'feilingshouhu'
                                },
                                {
                                    label: '零售户',
                                    value: 'lingshou'
                                }
                            ]
                        },
                        {
                            label: '期望完成日期',
                            field: 'completionTime',
                            type: 'date',
                            span: 8,
                        },
                        {
                            label: '数据用途',
                            field: 'dataUsage',
                            type: 'select',
                            items: rootState.dataUsage,
                            span: 8,
                        },
                        {
                            label: '其他分类',
                            field: 'otherCategories',
                            type: 'select',
                            items: rootState.otherCategories,
                            span: 8,
                        },
                        {
                            label: '报告发送方式',
                            field: 'reportDeliveryMode',
                            type: 'select',
                            span: 8,
                            items: [{
                                    label: '领取',
                                    value: 'lingqu'
                                },
                                {
                                    label: '邮寄',
                                    value: 'youij'
                                },
                                {
                                    label: '传真',
                                    value: 'chuanzhen'
                                },
                                {
                                    label: '其他',
                                    value: 'qita'
                                }
                            ]
                        },
                        {
                            label: '报告状态',
                            field: 'reportStatus',
                            span: 8,
                        },
                        {
                            label: '判定标准',
                            field: 'proStandardName',
                            span: 8,
                        },
                        {
                            label: '费用年度',
                            field: 'costYear',
                            type: 'date',
                            mode: 'year',
                            span: 8,
                        },
                        {
                            label: '检验室费用',
                            field: 'jysExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            label: '安全室费用',
                            field: 'aqsExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            label: '化学一室费用',
                            field: 'hxysExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            label: '化学二室费用',
                            field: 'hxesExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            label: '烟叶室费用',
                            field: 'yysExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            label: '评委会费用',
                            field: 'pwhExpenditure',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 32,
                                message: '字符长度必须在 0-32 之间'
                            }]
                        },
                        {
                            field: 'paytype',
                            label: '付款方式',
                            type: 'select',
                            items: [{
                                    label: '现金',
                                    value: 'cash'
                                },
                                {
                                    label: '汇款',
                                    value: 'remittance'
                                },
                                {
                                    label: '协议',
                                    value: 'protocol'
                                }
                            ],
                            span: 8
                        },
                        {
                            field: 'ext$.paystatus',
                            label: '付款状态',
                            type: 'select',
                            items: [{
                                    label: '已付',
                                    value: 'paid'
                                },
                                {
                                    label: '未付',
                                    value: 'unpaid'
                                }
                            ],
                            span: 8
                        },
                        {
                            field: 'ext$.invoicestatus',
                            label: '发票状态',
                            span: 8,
                            rules: [{
                                min: 0,
                                max: 18,
                                message: '字符长度必须在 0-18 之间'
                            }]
                        },
                        {
                            label: '创建时间',
                            field: 'createdTime',
                            type: 'date',
                            showTime: true,
                            span: 8
                        },
                        {
                            label: '余样处理方式',
                            field: 'completeTreatment',
                            span: 8,
                            type: 'select',
                            items: [{
                                    label: '/',
                                    value: 'default'
                                },
                                {
                                    label: '承检方处理',
                                    value: 'inspector'
                                },
                                {
                                    label: '委托方取回',
                                    value: 'client'
                                }
                            ]
                        },
                        {
                            label: '是否退还',
                            field: 'isReturn',
                            type: 'radioGroup',
                            span: 8,
                            items: [{
                                    label: '是',
                                    value: '1'
                                },
                                {
                                    label: '否',
                                    value: '0'
                                }
                            ]
                        },
                        {
                            label: '是否同意分包',
                            field: 'isSubpackage',
                            type: 'radioGroup',
                            span: 8,
                            items: [{
                                    label: '是',
                                    value: '1'
                                },
                                {
                                    label: '否',
                                    value: '0'
                                }
                            ]
                        },
                        {
                            label: '是否分包',
                            field: 'isSubcontract',
                            type: 'radioGroup',
                            span: 8,
                            items: [{
                                    label: '是',
                                    value: '1'
                                },
                                {
                                    label: '否',
                                    value: '0'
                                }
                            ]
                        },
                        {
                            label: '是否评审',
                            field: 'isReview',
                            type: 'radioGroup',
                            span: 8,
                            items: [{
                                    label: '是',
                                    value: '1'
                                },
                                {
                                    label: '否',
                                    value: '0'
                                }
                            ]
                        },
                        {
                            label: '检验依据',
                            field: 'inspectionBasis',
                            type: 'textarea',
                            span: 24,
                            rules: [{
                                min: 0,
                                max: 999,
                                message: '字符长度必须在 0-999 之间'
                            }]
                        },
                        {
                            label: '项目认可情况',
                            field: 'recognizedHappening',
                            span: 24,
                            rules: [{
                                min: 0,
                                max: 999,
                                message: '字符长度必须在 0-999 之间'
                            }]
                        },
                        {
                            label: '检测项目说明',
                            field: 'itemExplain',
                            span: 24
                        },
                        {
                            label: '其他说明',
                            field: 'otherInstructions',
                            span: 24
                        },
                        {
                            label: '备注',
                            field: 'remark',
                            type: 'textarea',
                            span: 24,
                            rules: [{
                                min: 0,
                                max: 999,
                                message: '字符长度必须在 0-2000 之间'
                            }]
                        },
                        {
                            label: '报告签章',
                            field: 'reportSignature',
                            type: 'select',
                            category: rootState.reportSignature,
                            span: 8
                        },
                        {
                            label: '是否判结论',
                            field: 'judgeConclusion',
                            type: 'radioGroup',
                            span: 8,
                            items: [{
                                    label: '是',
                                    value: '1'
                                },
                                {
                                    label: '否',
                                    value: '0'
                                }
                            ]
                        },
                        {
                            label: '委托项目',
                            field: 'entrustItem',
                            type: 'textarea',
                            span: 24,
                            rules: [{
                                min: 0,
                                max: 999,
                                message: '字符长度必须在 0-1200 之间'
                            }]
                        }
                    ]
                ]
            }
        ];
    },

    sampleFields(state, getters, rootState) {
        return [{
                id: 'jbxx',
                title: '基本信息',
                gutter: 32,
                fieldGroup: [
                    [{
                            label: '合同编号',
                            field: 'ext$.contractcode',
                            span: 24
                        },
                        {
                            label: '其他技术指标或原编号',
                            field: 'originalNumber',
                            span: 24
                        },
                        {
                            type: 'textarea',
                            label: '备注',
                            field: 'remark',
                            span: 24
                        }
                    ]
                ]
            },

            {
                id: 'ybtyxx',
                title: '样品通用信息',
                gutter: 32,
                fieldGroup: [
                    [{
                            label: '产品代码',
                            field: 'productCode',
                            span: 8
                        },
                        {
                            label: '样品名称',
                            field: 'mtlName',
                            span: 8,
                            rules: [{
                                required: true,
                                message: '样品名称'
                            }]
                        },
                        // {
                        //     label: '样品编号',
                        //     field: 'orderCode',
                        //     span: 8
                        // },
                        {
                            label: '产品类型',
                            field: 'productionType',
                            span: 8
                        },
                        {
                            label: '样品描述',
                            field: 'orderDesc',
                            span: 8
                        },
                        {
                            label: '商标',
                            field: 'ext$.trademark',
                            span: 8
                        },
                        {
                            type: 'select',
                            label: '样品状态',
                            field: 'ext$.orderstatus',
                            span: 8,
                            items: [{
                                    label: '满足检验要求',
                                    value: 'whole'
                                },
                                {
                                    label: '完好',
                                    value: 'good'
                                },
                                {
                                    label: '霉变',
                                    value: 'badwhole'
                                }
                            ]
                        },
                        {
                            type: 'date',
                            label: '生产时间',
                            field: 'productionTime',
                            span: 8
                        },
                        {
                            type: 'select',
                            label: '样品来源',
                            field: 'ext$.ordersources',
                            span: 8,
                            items: [{
                                    label: '寄样',
                                    value: '03'
                                },
                                {
                                    label: '送样',
                                    value: '02'
                                },
                                {
                                    label: '霉变',
                                    value: '01'
                                }
                            ]
                        },
                        {
                            type: 'select',
                            label: '存放位置',
                            field: 'ext$.position',
                            items: state.positionSelect,
                            span: 8,
                            category: 'lims-position'
                        },
                        {
                            label: '生产企业',
                            field: 'ext$.productioncompanyname',
                            span: 8
                        },
                        {
                            label: '生产企业代码',
                            field: 'ext$.productenterprisecode',
                            span: 8
                        },
                        {
                            label: '生产企业地址',
                            field: 'ext$.productadress',
                            span: 8
                        },
                        {
                            label: '送样人',
                            field: 'ext$.sender',
                            span: 8
                        },
                        {
                            label: '生产厂',
                            field: 'ext$.productplant',
                            span: 8
                        },
                        {
                            label: '生产厂代码',
                            field: 'ext$.productplantcode',
                            span: 8
                        },
                        {
                            label: '其他分类',
                            type: 'select',
                            field: 'otherCategories',
                            items: rootState.otherCategories,
                            span: 8
                        },
                        {
                            label: '抽样单位',
                            field: 'ext$.samplingunitname',
                            span: 8
                        },
                        {
                            field: 'ext$.sampledate',
                            label: '抽样日期',
                            type: 'date',
                            span: 8
                        },
                        {
                            field: 'sampleBaseNumber',
                            label: '抽样基数',
                            span: 8
                        },
                        {
                            field: 'sampleBaseNumberUnit',
                            label: '抽样基数单位',
                            type: 'select',
                            items: state.sampleType,
                            span: 8
                        },
                        {
                            label: '抽样依据',
                            field: 'ext$.samplingpurpose',
                            span: 8
                        },
                        {
                            field: 'ext$.sampleaddress',
                            label: '抽样地点',
                            span: 8
                        },
                        {
                            label: '抽样人',
                            field: 'ext$.sampler',
                            span: 8
                        },

                        // {
                        //     label: '报告签章',
                        //     type: 'select',
                        //     items: rootState.reportSignature,
                        //     span: 8
                        // },
                        {
                            field: 'ext$.acceptdate',
                            label: '收样日期',
                            type: 'date',
                            span: 8
                        }
                    ]
                ]
            },

            {
                id: 'yply',
                title: '样品领用信息',
                gutter: 32,
                fieldGroup: [
                    [{
                            label: '样品数量',
                            field: 'sampleCount',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '单位',
                            field: 'sampleCountUnit',
                            type: 'select',
                            items: state.sampleType,
                            span: 8
                        },
                        {
                            label: '退回数量',
                            field: 'returnNum',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '物检室领用数量',
                            field: 'inspectionRoomNumber',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '化学一室领用数量',
                            field: 'oneRoomNumber',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '化学二室领用数量',
                            field: 'twoRoomNumber',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '烟叶室领用数量',
                            field: 'tobaccoLeafNumber',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '评吸会领用数量',
                            field: 'commentaryNumber',
                            type: 'number',
                            span: 8
                        },
                        {
                            label: '安全室领用数量',
                            field: 'safeRoomNumber',
                            type: 'number',
                            span: 8
                        }
                    ]
                ]
            }
        ];
    },

    otherFields(state) {
        return [{
            id: 'other',
            title: '其他参数',
            gutter: 32,
            fieldGroup: [state.selectParameterFields]
        }];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};